import request from ".";

export const newsApi = {
  getNewsById: (newsId: string) =>
    request.post(`News/getNewsByUniqueUrl?UniqueUrl=${newsId}`),
  // getNewsById: (newsId: string) =>
  //   request.post(`News/getNewsByIdweb`, {
  //     NewsId: newsId,
  //   }),
  getRecentNews: (id: string) =>
    request.post(`News/GetTopNewsbyCount?Count=3&_post_id=${id}`),
  getAllNews: (size: number, page: number) =>
    request.post(
      `News/GetAllActiveNewsPagination?countPerPage=${size}&Page=${page}`
    ),
};
